export const RoutesPaths = {
  LOGIN: "/",
  VERIFY_OTP: "/verify-otp",
  DASHBOARD: "/dashboard",
  DATA_QUALITY: "/data-quality",
  DQ_DUPLICATES: "/data-quality/duplicates",
  RISK: "/risk-compliance",
  RELATIONSHIPS: "/relationships",
  AUDIT: "/audit-intelligence",
  NIF_REGISTRATION: "/nif-registration",
  DI_SOURCES: "/data-integration/sources",
  DI_IMPORT: "/data-integration/import",
  DI_SYNC: "/data-integration/synchronization",
  REPORTS: "/reports",
  SECURITY: "/security-logs",
  USER_MANAGEMENT: "/user-management",
  SETTINGS: "/settings",
  TAXPAYERS: "/taxpayers",
  TAXPAYER_DETAIL: "/taxpayers/:nif",
};

// Builds a concrete detail path from the parameterised route above.
export const taxpayerDetailPath = (nif) => `/taxpayers/${nif}`;
